module.exports = __webpack_public_path__ + "img/grey.5922df5.svg";